import { UserInterface } from "@kanvas/client-js";
import { atom } from "jotai";

export const UserAtom = atom<UserInterface | null>(null);
